import { useVirtualizer } from '@tanstack/react-virtual'
import { useRef } from 'react'

/**
 * 表格虚拟滚动容器：spacer + absolute 行定位。
 */
export function useVirtualTable({ count, estimateSize = 44, overscan = 12 }: {
  count: number
  estimateSize?: number
  overscan?: number
}) {
  const containerRef = useRef<HTMLDivElement>(null)
  // TanStack Virtual 返回不可 memo 的函数，属已知限制（react-compiler 跳过优化）
  // eslint-disable-next-line react-hooks/incompatible-library
  const virtualizer = useVirtualizer({
    count,
    getScrollElement: () => containerRef.current,
    estimateSize: () => estimateSize,
    overscan,
  })
  return { containerRef, virtualizer }
}
